/**
 * @title Terms Page
 * @description Standalone Terms and Conditions page
 */
import * as React from "react";
import {FC} from "react";
import {useNavigate} from "react-router-dom";
import {PrivateRenderer} from "../PrivateRenderer";
import {TermsAndConditionsDialog} from "../../../components/TermsAndConditionsDialog";
import {ReturnsPagePath} from "../returns/ReturnsPage";

export const TermsPagePath = (id?: string) => {
  if (id) {
    return ReturnsPagePath() + '/tradein/' + id + '/terms';
  } else {
    return ReturnsPagePath() + '/tradein/terms';
  }
};

export const TermsPage: FC<any> = () => {
  const navigate = useNavigate();

  const onHideDialog = () => {
    navigate(-1); // Go back when closing the dialog
  };

  return (
    <PrivateRenderer step={"tradein"} hideSteppers={true}>
      <TermsAndConditionsDialog 
        open={true} 
        onHideDialog={onHideDialog} 
        fullScreen={false}
      />
    </PrivateRenderer>
  );
};